import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';
import BootstrapVue from 'bootstrap-vue';
import UserService from "@/services/UserService";
import GlobalService from "@/services/GlobalService";
import browserDetect from "vue-browser-detect-plugin";
import VCalendar from 'v-calendar';
import infiniteScroll from 'vue-infinite-scroll';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(browserDetect);
Vue.use(infiniteScroll);
Vue.use(VCalendar, {
  formats: {
    title: 'MMMM YYYY',
    input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
    navVisibility: 'focus',
    popoverVisibility: 'focus'
  }
});

(VueCookies as any).config('30d');

Vue.prototype.$userService = new UserService();
Vue.prototype.$globalService = new GlobalService();

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
